import React, { useState, useEffect } from "react";
import { googleLogout } from "@react-oauth/google";
import { CircularProgress, Alert, Snackbar, Container, Button, Typography, Stack } from "@mui/material";
import { v4 as uuidv4 } from 'uuid'; // Importe la fonction pour générer un UUID v4
import Presentation from "./presentation";
import InfoPersonnelles from "./infopersonnelles";
import Vendredi from "./vendredi";
import Samedi from "./samedi";
import Dimanche from "./dimanche";
import Lundi from "./lundi";
import FormulaireFerme from "./formulaire_fermer";

const App = () => {
  const [isInitializing, setIsInitializing] = useState(true);
  const [accessToken, setAccessToken] = useState(false);

  const [open_snackbar, setOpen_snackbar] = React.useState(false);
  const [snackbar_message, setSnackbar_message] = React.useState('');
  const [snackbar_severity, setSnackbar_severity] = React.useState('success');

  const [liste_structure, setListe_structure] = useState([]);
  const [liste_role, setListe_role] = useState([]);

  const [liste_inscrit, setListe_inscrit] = useState([]);
  const [ligne_nouvelle_inscription, setLigne_nouvelle_inscription] = useState(0);

  const [info_perso, setInfo_perso] = useState(null);
  const [trigger_reset_info_perso, setTrigger_reset_info_perso] = useState(false);

  const [data_vendredi, setData_vendredi] = useState([]);
  const [vendredi, setVendredi] = useState({
        c_09_12: '',
        c_15_17: '',
        c_17_22: '',
        repas: false
      });
  const [trigger_reset_vendredi, setTrigger_reset_vendredi] = useState(false);

  const [data_samedi_pair, setData_samedi_pair] = useState([]);
  const [data_samedi_impair, setData_samedi_impair] = useState([]);
  const [samedi, setSamedi] = useState(null);
  const [trigger_reset_samedi, setTrigger_reset_samedi] = useState(false);

  const [data_dimanche_pair, setData_dimanche_pair] = useState([]);
  const [data_dimanche_impair, setData_dimanche_impair] = useState([]);
  const [dimanche, setDimanche] = useState(null);
  const [trigger_reset_dimanche, setTrigger_reset_dimanche] = useState(false);

  const [data_lundi, setData_lundi] = useState([]);
  const [lundi, setLundi] = useState({
        c_09_12: '',
        c_12_15: '',
      });
  const [trigger_reset_lundi, setTrigger_reset_lundi] = useState(false);

  const [inscription_validee, setInscription_validee] = useState(false);

  const [is_benevole, set_is_benevole] = useState(false);

  const [afficher_planning, set_afficher_planning] = useState(false);

  const aujourdHui = new Date();
  const dateCible = new Date('2026-04-11T00:00:00');
  const date_limite_atteinte = aujourdHui > dateCible ? true : false

  //---------------------------------------------------------------------------
  // Permet de déconnecter automatiquement après validation de l'inscription
  //---------------------------------------------------------------------------
  useEffect(() => {
    const timer = setTimeout(() => {
      if (inscription_validee) {
        // Femer la session de login
        googleLogout();
        setAccessToken(false);
        setInscription_validee(false);
      }
    }, 5000); // 5000 millisecondes = 5 secondes

    // Cleanup function pour annuler le timer si le composant est démonté
    return () => clearTimeout(timer);
  }, [inscription_validee]); // Le tableau de dépendances vide signifie que cet effet s'exécute une seule fois après le premier rendu

  //---------------------------------------------------------------------------
  // Lire une plage de données
  //---------------------------------------------------------------------------
  const lire = async (range) => {
    const data = await fetchData(range);
    console.log(data.map((item) => item[0]));
    return (data.map((item) => item[0]));
  };

  //---------------------------------------------------------------------------
  // Lire les données une fois que la connexion est OK
  //---------------------------------------------------------------------------
  useEffect(() => {
    if (accessToken) {
      lireDonnees();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken]);

  //---------------------------------------------------------------------------
  // Lire les données des inscriptions
  //---------------------------------------------------------------------------
  const lireDonnees = async () => {
    // Lire les données nécessaires pour les infos personnelles
    setListe_structure(await lire('Donnees!A2:A100'));
    setListe_role(await lire('Donnees!F2:F6'));
    setListe_inscrit(await lire('Inscriptions!A:A'));

    // Lire toute les données des créneaux du vendredi au lundi
    const data_vendredi = await fetchData('Vendredi!A2:L20');
    setData_vendredi(data_vendredi);

    const data_samedi_pair = await fetchData('Samedi pair!A2:AJ20');
    const data_samedi_impair = await fetchData('Samedi impair!A2:AF20');
    setData_samedi_pair(data_samedi_pair);
    setData_samedi_impair(data_samedi_impair);

    const data_dimanche_pair = await fetchData('Dimanche pair!A2:X20');
    const data_dimanche_impair = await fetchData('Dimanche impair!A2:P20');
    setData_dimanche_pair(data_dimanche_pair);
    setData_dimanche_impair(data_dimanche_impair);

    const data_lundi = await fetchData('Lundi!A2:H20');
    setData_lundi(data_lundi);

    setIsInitializing(false);
  };


  //---------------------------------------------------------------------------
  // Calculer la ligne du nouvel inscrit
  //---------------------------------------------------------------------------
  useEffect(() => {
    setLigne_nouvelle_inscription(liste_inscrit.length + 1);
  }, [liste_inscrit]);

  //---------------------------------------------------------------------------
  // Gérer la connexion OAuth
  //---------------------------------------------------------------------------
  const login = () => {
    setAccessToken(true);
  };

  //---------------------------------------------------------------------------
  // Lecture des données
  //---------------------------------------------------------------------------
  const fetchData = async (range) => {
    try {


      const response = await fetch(`https://acces-formulaire-benevoles.benevolespaj.workers.dev/values?range=${range}`, {
        method: "GET",
        // Pas besoin de credentials; CORS autorise l'origine configurée
      });

      if (response.ok) {
        const result = await response.json();
        return (result.values || []);
      } else {
        setSnackbar_message("Il y a eu un problème lors de la récupération des données du formulaire ! Cela est peut être dû à votre réseau qui bloque certains accès...");
        setSnackbar_severity('error');
        setOpen_snackbar(true);
        console.error("Erreur lors de la récupération des données :", response.status);
      }
    } catch (error) {
      console.error("Erreur :", error);
    }
    return ([]);
  };

  //---------------------------------------------------------------------------
  // Ecriture des données
  //---------------------------------------------------------------------------
  const writeData = async (range, values) => {

    try {

      const response = await fetch("https://acces-formulaire-benevoles.benevolespaj.workers.dev/values", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          range: range,
          values: values,
          valueInputOption: "RAW",
        }),
      });

      console.log(response);
      if (response.ok) {
        console.log("Données écrites avec succès !");
        return true;
      } else {
        setSnackbar_message("Il y a eu un problème lors de l'envoie des données du formulaire ! Cela est peut être dû à votre réseau qui bloque certains accès...");
        setSnackbar_severity('error');
        setOpen_snackbar(true);
        console.log("Erreur lors de l'écriture des données.");
      }
    } catch (error) {
      console.error("Erreur : ", error);
    }
    return false;
  };

  //---------------------------------------------------------------------------
  // Vérifie les créneaux 2 par 2
  //---------------------------------------------------------------------------
  const checkCreneau = (c1, c2, label_c1, label_c2) => {
    if ((c1.length > 0) && (c2.length > 0)) {
      setSnackbar_message(`Les créneaux ${label_c1} et ${label_c2} se chevauchent !`);
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return (false);
    }
    return (true);
  };

  //---------------------------------------------------------------------------
  // Valide l'inscription
  //---------------------------------------------------------------------------
  const validerInscription = async () => {
    // Récupérer les informations personnelles en enlevant les espace avant et après
    const new_prenom = info_perso.prenom.trim();
    const new_nom = info_perso.nom.trim();
    const new_telephone = info_perso.telephone.trim();
    const new_mail = info_perso.mail.trim();
    const new_structure = info_perso.structure.trim();
    const new_role = info_perso.role.trim();

    // Vérifier que les informations personnelles obligatoires sont bien remplies
    if (new_prenom.length === 0) {
      setSnackbar_message("Tu n'as pas donné ton prénom !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }
    if (new_nom.length === 0) {
      setSnackbar_message("Tu n'as pas donné ton nom !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }
    if (new_telephone.length === 0) {
      setSnackbar_message("Tu n'as pas donné ton N° de téléphone !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }
    if (new_mail.length === 0) {
      setSnackbar_message("Tu n'as pas donné ton adresse mail !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }
    if (new_structure.length === 0) {
      setSnackbar_message("Tu n'as pas dit à quelle association ou entreprise tu apppartiens !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }
    if (new_role.length === 0) {
      setSnackbar_message("Tu n'as pas dit ce que tu allais faire pendant le festival !");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
      return;
    }

    // Vérifier que les postes sur les créneaux du samedi ne se chevauchent pas
    if ((!checkCreneau(samedi.c_08_10, samedi.c_09_11, 'Samedi 08h00-10h00', 'Samedi 09h00-11h00')) ||
      (!checkCreneau(samedi.c_09_11, samedi.c_10_12, 'Samedi 09h00-11h00', 'Samedi 10h00-12h00')) ||
      (!checkCreneau(samedi.c_10_12, samedi.c_11_13, 'Samedi 10h00-12h00', 'Samedi 11h00-13h00')) ||
      (!checkCreneau(samedi.c_11_13, samedi.c_12_14, 'Samedi 11h00-13h00', 'Samedi 12h00-14h00')) ||
      (!checkCreneau(samedi.c_12_14, samedi.c_13_15, 'Samedi 12h00-14h00', 'Samedi 13h00-15h00')) ||
      (!checkCreneau(samedi.c_13_15, samedi.c_14_16, 'Samedi 13h00-15h00', 'Samedi 14h00-16h00')) ||
      (!checkCreneau(samedi.c_14_16, samedi.c_15_17, 'Samedi 14h00-16h00', 'Samedi 15h00-17h00')) ||
      (!checkCreneau(samedi.c_15_17, samedi.c_16_18, 'Samedi 15h00-17h00', 'Samedi 16h00-18h00')) ||
      (!checkCreneau(samedi.c_16_18, samedi.c_17_19, 'Samedi 16h00-18h00', 'Samedi 17h00-19h00')) ||
      (!checkCreneau(samedi.c_17_19, samedi.c_18_20, 'Samedi 17h00-19h00', 'Samedi 18h00-20h00')) ||
      (!checkCreneau(samedi.c_18_20, samedi.c_19_21, 'Samedi 18h00-20h00', 'Samedi 19h00-21h00')) ||
      (!checkCreneau(samedi.c_19_21, samedi.c_20_22, 'Samedi 19h00-21h00', 'Samedi 20h00-22h00')) ||
      (!checkCreneau(samedi.c_20_22, samedi.c_21_23, 'Samedi 20h00-22h00', 'Samedi 21h00-23h00')) ||
      (!checkCreneau(samedi.c_21_23, samedi.c_22_00, 'Samedi 21h00-23h00', 'Samedi 22h00-00h00')) ||
      (!checkCreneau(samedi.c_22_00, samedi.c_23_01, 'Samedi 22h00-00h00', 'Samedi 23h00-01h00')) ||
      (!checkCreneau(samedi.c_23_01, samedi.c_00_02, 'Samedi 23h00-01h00', 'Samedi 00h00-02h00'))) {
      return;
    }

    // Vérifier que les postes sur les créneaux du dimanche ne se chevauchent pas
    if ((!checkCreneau(dimanche.c_08_10, dimanche.c_09_11, 'Dimanche 08h00-10h00', 'Dimanche 09h00-11h00')) ||
      (!checkCreneau(dimanche.c_09_11, dimanche.c_10_12, 'Dimanche 09h00-11h00', 'Dimanche 10h00-12h00')) ||
      (!checkCreneau(dimanche.c_10_12, dimanche.c_11_13, 'Dimanche 10h00-12h00', 'Dimanche 11h00-13h00')) ||
      (!checkCreneau(dimanche.c_11_13, dimanche.c_12_14, 'Dimanche 11h00-13h00', 'Dimanche 12h00-14h00')) ||
      (!checkCreneau(dimanche.c_12_14, dimanche.c_13_15, 'Dimanche 12h00-14h00', 'Dimanche 13h00-15h00')) ||
      (!checkCreneau(dimanche.c_13_15, dimanche.c_14_16, 'Dimanche 13h00-15h00', 'Dimanche 14h00-16h00')) ||
      (!checkCreneau(dimanche.c_14_16, dimanche.c_15_17, 'Dimanche 14h00-16h00', 'Dimanche 15h00-17h00')) ||
      (!checkCreneau(dimanche.c_15_17, dimanche.c_16_18, 'Dimanche 15h00-17h00', 'Dimanche 16h00-18h00'))) {
      return;
    }

    // Calcul de la date et heure courante
    const now = new Date();
    const pad = (n) => (n < 10 ? '0' + n : n);
    const date_heure = `${pad(now.getDate())}/${pad(now.getMonth() + 1)}/${now.getFullYear()} ${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;

    // Créer le GUID
    const guid = uuidv4();
    console.log(guid);

    // Formater les repas
    const repas_v_s = vendredi.repas ? 'OUI' : 'NON';
    const repas_s_m = samedi.repas_midi ? 'OUI' : 'NON';
    const repas_s_s = samedi.repas_soir ? 'OUI' : 'NON';
    const repas_d_m = dimanche.repas_midi ? 'OUI' : 'NON';

    // Construction du tableau de données, mettre 'envoyer le mail' dans la dernière case pour que le script puisse l'envoyer
    const data = [[date_heure, new_prenom, new_nom, new_telephone, new_mail, new_structure, new_role, 
      vendredi.c_09_12, 
      vendredi.c_15_17, 
      vendredi.c_17_22,
      samedi.c_08_10, 
      samedi.c_09_11, 
      samedi.c_10_12, 
      samedi.c_11_13, 
      samedi.c_12_14, 
      samedi.c_13_15, 
      samedi.c_14_16, 
      samedi.c_15_17, 
      samedi.c_16_18, 
      samedi.c_17_19, 
      samedi.c_18_20,
      samedi.c_19_21, 
      samedi.c_20_22, 
      samedi.c_21_23, 
      samedi.c_22_00, 
      samedi.c_23_01, 
      samedi.c_00_02,
      dimanche.c_08_10, 
      dimanche.c_09_11, 
      dimanche.c_10_12, 
      dimanche.c_11_13, 
      dimanche.c_12_14, 
      dimanche.c_13_15, 
      dimanche.c_14_16, 
      dimanche.c_15_17,
      dimanche.c_16_18, 
      dimanche.c_18_22,
      lundi.c_09_12, 
      lundi.c_12_15,
      repas_v_s, repas_s_m, repas_s_s, repas_d_m, 'envoyer le mail', guid
    ]];

    const Liste_inscrit = await lire('Inscriptions!A:A');
    const nouvelle_inscription = Liste_inscrit.length + 1;
    console.log(nouvelle_inscription);

    const inscription_validee = await writeData(`Inscriptions!A${nouvelle_inscription}:AS${nouvelle_inscription}`, data);

    if (inscription_validee) {
      setSnackbar_message('Ton inscription est validée ! Merci pour ton engagement ! Tu vas être redirigé·e automatiquement vers la page de connexion.')
      setSnackbar_severity('success');
      setOpen_snackbar(true);
      setInscription_validee(true);

      // Vider les infos personnelles et le planning et les repas
      setTrigger_reset_info_perso(true);
      setTrigger_reset_vendredi(true);
      setTrigger_reset_samedi(true);
      setTrigger_reset_dimanche(true);
      setTrigger_reset_lundi(true);

    }
    else {
      setSnackbar_message("Un problème est survenu lors de votre inscription, merci d'essayer de nouveau ultérieurement. En cas de problème persistant, merci de contacter l'équipe via le mail benevolespaj@gmail.com");
      setSnackbar_severity('error');
      setOpen_snackbar(true);
    }
  };

  //---------------------------------------------------------------------------
  // gestion des informations perso
  //---------------------------------------------------------------------------
  const handleInfoPerso = (infos) => {
    if (infos.role === "") {
      set_afficher_planning(false);
    }
    else {
      set_afficher_planning(true);
      if (infos.role.includes("Bénévole")) {
        console.log("role: " + infos.role);
        set_is_benevole(true);
      }
      else {
        set_is_benevole(false);
      }
    }
    setInfo_perso(infos);
    setTrigger_reset_info_perso(false);
  };

  //---------------------------------------------------------------------------
  // gestion des informations du vendredi
  //---------------------------------------------------------------------------
  const handleVendredi = (vendredi) => {
    setVendredi(vendredi);
    setTrigger_reset_vendredi(false);
  };

  //---------------------------------------------------------------------------
  // gestion des informations du samedi
  //---------------------------------------------------------------------------
  const handleSamedi = (samedi) => {
    setSamedi(samedi);
    setTrigger_reset_samedi(false);
  };

  //---------------------------------------------------------------------------
  // gestion des informations du dimanche
  //---------------------------------------------------------------------------
  const handleDimanche = (dimanche) => {
    setDimanche(dimanche);
    setTrigger_reset_dimanche(false);
  };

  //---------------------------------------------------------------------------
  // gestion des informations du lundi
  //---------------------------------------------------------------------------
  const handleLundi = (lundi) => {
    setLundi(lundi);
    setTrigger_reset_lundi(false);
  };

  //---------------------------------------------------------------------------
  // gestion du snackbar
  //---------------------------------------------------------------------------
  const snackbar_handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpen_snackbar(false);
  };

  //---------------------------------------------------------------------------
  // HMI
  //---------------------------------------------------------------------------
  return (
    <Container style={{ marginTop: "50px" }}>

      {date_limite_atteinte && (
        <FormulaireFerme />

      )}

      {!accessToken && !date_limite_atteinte && (
        <Stack>

          <Presentation />

          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
            onClick={() => login()} >
            S'inscrire
          </Button>
          <Typography variant="h1" align="center">&nbsp;</Typography>

        </Stack>
      )}

      {accessToken && isInitializing && !date_limite_atteinte && (
        <Stack justifyContent='center' alignItems='center'>
          <CircularProgress size={80} thickness={5} />
        </Stack>
      )}

      {accessToken && !isInitializing && !date_limite_atteinte && !inscription_validee && (
        <Stack spacing={1} alignItems={'center'}>

          <InfoPersonnelles
            liste_structure={liste_structure}
            liste_role={liste_role}
            triggerResetInfoPerso={trigger_reset_info_perso}
            onInfoPersoChange={handleInfoPerso}
          />

          {afficher_planning && (
            <Stack spacing={1} alignItems={'center'} sx={{ width: '100%' }}>
              {is_benevole && (
                <Typography variant="h4" align="center">
                  Mon planning
                </Typography>
              )}
              {!is_benevole && (
                <Typography variant="h4" align="center">
                  Mes repas
                </Typography>
              )}

              {is_benevole && (
                <Vendredi
                  data_vendredi={data_vendredi}
                  triggerResetVendredi={trigger_reset_vendredi}
                  onVendrediChange={handleVendredi}
                />
              )}

              <Samedi
                data_samedi_impair={data_samedi_impair}
                data_samedi_pair={data_samedi_pair}
                triggerResetSamedi={trigger_reset_samedi}
                onSamediChange={handleSamedi}
                is_benevole={is_benevole}
              />

              <Dimanche
                data_dimanche_impair={data_dimanche_impair}
                data_dimanche_pair={data_dimanche_pair}
                triggerResetDimanche={trigger_reset_dimanche}
                onDimancheChange={handleDimanche}
                is_benevole={is_benevole}
              />

              {is_benevole && (
                <Lundi
                  data_lundi={data_lundi}
                  triggerResetLundi={trigger_reset_lundi}
                  onLundiChange={handleLundi}
                />
              )}

            </Stack>
          )}

          <Button
            variant="contained"
            color="primary"
            style={{ marginTop: "20px" }}
            onClick={() => { validerInscription(); }} >
            Valider mon inscription !
          </Button>

          <Typography variant="h1" align="center">&nbsp;</Typography>

        </Stack>
      )}

      <Snackbar
        open={open_snackbar}
        onClose={snackbar_handleClose}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
        <Alert
          onClose={snackbar_handleClose}
          severity={snackbar_severity}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {snackbar_message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default App;
